import type { FallbackProps } from 'react-error-boundary'
import { Box, Button, Typography } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

/**
 * ErrorFallback — shown by ErrorBoundary when a component crashes.
 * Shows a user-friendly message and a reset button.
 */
export const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      gap: 2,
    }}
  >
    <ErrorOutlineIcon sx={{ fontSize: 64, color: 'error.main' }} />
    <Typography variant="h5" fontWeight={600}>
      Something went wrong
    </Typography>
    <Typography variant="body2" color="text.secondary" maxWidth={400} textAlign="center">
      {error?.message ?? 'An unexpected error occurred. Please try again.'}
    </Typography>
    <Button variant="contained" onClick={resetErrorBoundary}>
      Try Again
    </Button>
  </Box>
)
